module.exports = __webpack_public_path__ + "img/cases-map.57a2596e.png";